import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter, Input } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { DateQualifierService, DateRequirements } from 'src/app/model/api-services/qualifiers/date-qualifier.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

import * as moment from 'moment-mini-ts';
import { Validator } from 'src/app/model/validator';

@Component({
	selector: 'app-time-input',
	templateUrl: './time-input.component.html',
	styleUrls: ['./time-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush

})
export class TimeInputComponent
	extends InputComponent
	implements OnInit {

	public useDateOnly = false;
	public useTimeOnly = false;
	public useDateTime = false;
	public defaultValue: '' | 'NOW' = '';
	public minDate = '';
	public maxDate = '';
	private _timeValue: any;
	@Input()
	public validator: Validator = null;

	public set currentValue(val: any) {
		if ([null, undefined, 0, ''].indexOf(val) > -1) {
			super.currentValue = '';
			this.cdr.detectChanges();
			return;
		}
		const castingType = (this.hasCasting === true) ? this.attribute.type : '';

		switch (castingType) {
			case 'text':
			case 'string':
				if (typeof val === 'string') {
					val = val.toUpperCase();
					let time = val;
					if (this.attribute && this.attribute.casting && this.attribute.casting.entry) {
						if (this.attribute.casting.entry.type === 'time') {
							const date = DateQualifierService.FromString(val.toUpperCase(), this.attribute.casting.entry.format);
							time = DateQualifierService.ToString(date, 'date#13:30');
						}
					}
					super.currentValue = time;
					this.time = time;
					this.validator.SetValue(this.attribute.name, val);
				}

		}

	}
	public get currentValue(): any {
		if (this.hasCasting) {
			switch (this.attribute.type) {
				case 'text':
				case 'string':
					if (this.attribute.casting.entry) {
						const date = DateQualifierService.FromString(this.time, 'date#13:30');
						return DateQualifierService.ToString(date, this.attribute.casting.entry.format);
					}
			}
		}
		this.cdr.detectChanges();
		return '';


	}
	public get currentTime(): string {
		if (this.hasCasting && !!this.GetSuperValue()) {
			switch (this.attribute.type) {
				case 'text':
				case 'string':
					const date = DateQualifierService.FromString(this._timeValue, 'date#13:30');
					return DateQualifierService.ToString(date, this.casting.format)
				default:
					return this._timeValue;
			}
		} else {
			if (this.currentValue !== '') {
				return this.currentValue;
				// return DateQualifierService.DBToDate(this.currentValue);
			}
		}
		return null;
	}

	public set time(val: string) {
		if (['', undefined, null, 0].indexOf(val) > -1) {
			if (this._timeValue !== '') {
				this._timeValue = '';
				this.currentValue = '';
				this.cdr.detectChanges();
				return;
			}
			return;
		}
		this._timeValue = val;
		this.validator.SetValue(this.attribute.name, this.currentTime);
		/* const newDate = new Date();
		const timeParts: Array<string> = val.split(':');
		newDate.setHours(Number(timeParts[0]));
		newDate.setMinutes(Number(timeParts[1]));
		newDate.setSeconds(0);
		newDate.setMilliseconds(0);
		this.currentValue = newDate;*/
		this.dateValueChange.emit(this._timeValue);

		this.cdr.detectChanges();
	}
	public get time(): string {
		return this._timeValue;
		/*if (['', undefined, null, 0].indexOf(this.currentValue) > -1) { return ''; }
		const dateStr: string = (this.currentValue as Date).toJSON();
		const dateTime: Array<string> = dateStr.split('T');
		if (this.useDateOnly === true) {
			return dateTime[0];
		}
		if (this.useDateTime === true) {
			return dateStr;
		}
		if (this.useTimeOnly === true) {
			if (dateTime.length > 1) {
				return dateTime[1];
			}
			return '';
		}*/
	}
	@Output()
	public dateValueChange = new EventEmitter<string>();
	constructor(private domNode: ElementRef, protected cdr: ChangeDetectorRef) {
		super(cdr);
		super._domNode = this.domNode;

	}

	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);
		let hadCasting = false;
		if (!!attribute.casting) {
			if (!!attribute.casting.entry) {
				hadCasting = true;
			}
		}
		this.cdr.detectChanges();
	}


	ngOnInit(): void {
		if (!this.initialized) {
			super.ngOnInit();
		}

	}



}
